<template>
    <div>

    </div>
</template>

<script>
export default {
    methods: {
        validate() {
            return Promise.resolve();
        },
        init() {
        }
    }
}
</script>

<style scoped>

</style>